import { render, staticRenderFns } from "./stock-inventory-modal.vue?vue&type=template&id=5a3852d1&"
import script from "./stock-inventory-modal.vue?vue&type=script&lang=js&"
export * from "./stock-inventory-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports